<div>
    <canvas
    class="mb-3"
     baseChart width="400" height="300"
    [type]="'line'"
    [data]="lineChartData"
    [options]="lineChartOptions"
    [legend]="lineChartLegend"
    >
    </canvas>
</div>